import React from "react";
import { Button } from "@vitalsource/vstui";
var MenuMixin = require("../ui_elements/menu").MenuMixin;
var Isvg = require("../../../vendor/react-inlinesvg");

/*
  Renders a list (typically to go into a menu)
    props:
    state:
*/
class MenuList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};

    // MenuMixin methods
    this._toggleMenu = MenuMixin._toggleMenu.bind(this);
    this._showMenu = MenuMixin._showMenu.bind(this);
    this._removeMenu = MenuMixin._removeMenu.bind(this);
    this._redrawMenu = MenuMixin._redrawMenu.bind(this);

    // Callback bindings
    this._clickMenuItem = this._clickMenuItem.bind(this);
  }

  _clickMenuItem(e) {
    e.preventDefault();
    var menuData = Fraction.Helpers.getDataObject("_reserved.context-menu");
    if (this.props.items[$(e.currentTarget).data("item-id")].clickEvent) {
      this.props.items[$(e.currentTarget).data("item-id")].clickEvent(e);
    }

    this._removeMenu();
    //$(menuData.refocusDOM).focus();
  }

  _getWidthOfMenuList() {
    var menuSize = -1;
    for (var i = 0; i < this.props.items.length - 1; i++) {
      if (this.props.items[i].divider) {
        continue; // Don't check width of a divider
      }
      var tmp = this.props.items[i].label.size();
      if (tmp.width > menuSize.width) {
        menuSize = tmp;
      }
    }
  }

  render() {
    var items = [];
    var html, menuContent;
    for (var i = 0; i < this.props.items.length; i++) {
      var menuItem = this.props.items[i];
      var menuButtonAttr = {
        className: "noButton",
        "data-item-id": i,
        "data-attribute": menuItem.attribute,
        onClick: this._clickMenuItem,
        "aria-pressed": menuItem.checked
      };
      var menuButtonMarkup = (
        <span>
          <span className="context-menu-button-label">
            {menuItem.userLabel || window.toHTML(menuItem.label)}
            {menuItem.checked && (
              <Isvg className="checked-context-item" src="/img/checkmark.svg" />
            )}
          </span>
        </span>
      );

      if (menuItem.divider) {
        items.push(
          <li key={"divider" + i} className="divider" aria-hidden="true">
            <hr />
          </li>
        );
      } else if (menuItem.userLabel) {
        items.push(
          <li
            key={"menu-list-item" + i + "-" + menuItem.key}
            className={
              "context-menu-option" +
              (menuItem.highlighted ? " highlighted" : "")
            }
          >
            <Button
              naked
              href="#"
              {...menuButtonAttr}
              target={menuItem.target || "_self"}
            >
              {menuButtonMarkup}
            </Button>
          </li>
        );
      } else if (menuItem.html) {
        items.push(menuItem.html);
      } else {
        items.push(
          <li
            key={"menu-list-item" + i + "-" + menuItem.label}
            className={
              "context-menu-option" +
              (menuItem.highlighted ? " highlighted" : "")
            }
          >
            {menuItem.highlighted !== undefined ||
            menuItem.checked !== undefined ? (
              <button
                {...menuButtonAttr}
                id={menuItem.id ? menuItem.id : ""}
                aria-pressed={
                  menuItem.highlighted || menuItem.checked ? "true" : "false"
                }
              >
                {menuButtonMarkup}
              </button>
            ) : (
              <button {...menuButtonAttr} id={menuItem.id ? menuItem.id : ""}>
                {menuButtonMarkup}
              </button>
            )}
          </li>
        );
      }
    }
    return <ul className="context-menu-option-list">{items}</ul>;
  }
}

module.exports = MenuList;
